import { useEffect, useState } from 'react';

export default function ArticleProgressBar({ targetRef }) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    function onScroll() {
      const el = targetRef?.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const articleHeight = el.offsetHeight;
      // Progress: how much of article has passed above viewport center
      const scrolled = Math.min(Math.max(-rect.top + vh * 0.3, 0), articleHeight);
      setProgress(articleHeight > 0 ? Math.min(100, (scrolled / articleHeight) * 100) : 0);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
  }, [targetRef]);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent pointer-events-none" data-testid="article-progress">
      <div className="h-full bg-[#e11d48] transition-[width] duration-75" style={{ width: `${progress}%` }} />
    </div>
  );
}
